import styled from 'styled-components';

export const ButtonContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px;

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 8px;

    > div {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 4px;

      img {
        width: 16px;
        padding: 0;
      }

      span {
        font-size: 11px;
      }
    }
  }
`;
